var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 34.5C27.4485 34.5 34.5 27.4485 34.5 18.75C34.5 10.0515 27.4485 3 18.75 3C10.0515 3 3 10.0515 3 18.75C3 27.4485 10.0515 34.5 18.75 34.5Z",
    stroke: "#8A96A3",
    strokeWidth: 3.09836,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3613 21.6491C14.3613 23.1093 15.5451 24.293 17.0053 24.293H19.4603C21.0248 24.293 22.2931 23.0247 22.2931 21.4602C22.2931 19.8957 21.0248 18.6275 19.4603 18.6275H17.1941C15.6296 18.6275 14.3613 17.3592 14.3613 15.7947C14.3613 14.2302 15.6296 12.9619 17.1941 12.9619H19.6492C21.1094 12.9619 22.2931 14.1456 22.2931 15.6058M18.3272 11.2622V12.9619M18.3272 24.293V25.9927",
    stroke: "#8A96A3",
    strokeWidth: 2.58197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipIcon);
export default __webpack_public_path__ + "static/media/tip_icon.01dcd95080b46624558b2afe899182c7.svg";
export { ForwardRef as ReactComponent };